// extracted by mini-css-extract-plugin
export default {"chartsLayout":"elo-details_chartsLayout__5vPY+","backButton":"elo-details_backButton__wDRs5"};